// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"c3c4da49","31":"772d7f51","62":"fefd890a","74":"a3de6703","205":"48769967","264":"f04ddce2","350":"3a20f423","369":"992ad2a5","598":"f5c645ca","631":"5d550a2b","716":"679e62b0","833":"934181c3"}[chunkId] + ".chunk.css";
};